<template>
  <div class="wrapper">
    <img class="logo" src="@/assets/images/vw_academy.svg?external" alt="" />
    <div class="content">
      <p class="header">
        In order to download the
        <strong>Hololens Drivers Assistance Application,</strong> click on the button below. Please note that this
        application is optimized for Apple iPad and may not display correctly on an iPhone or similar.
      </p>
      <a href="https://apps.eventon.site/?f=2095/temp_atlas.ipa" target="_blank" rel="noopener">
        <button>Download</button>
      </a>
      <div class="license">
        <img class="pdf-icon" src="@/assets/images/pdf.svg?external" alt="" />
        <span>
          You may need to accept the license agreement for this application. In order to learn how,
          <a href="/VW_HololensApp_TrustInstructions_091120.pdf" target="_blank" rel="noopener"> click here.</a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style>
body {
  background-color: #001e50;
  margin: 0;
}
</style>

<style lang="scss" scoped>
@mixin for-phone-only {
  @media (max-width: 599px) {
    @content;
  }
}
@mixin for-tablet-only {
  @media (max-width: 899px) {
    @content;
  }
}
.wrapper {
  padding: 35px 0px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100vh;
  box-sizing: border-box;
}
.logo {
  margin: 0 40px;
  flex-shrink: 0;
}
.content {
  padding: 35px 70px;
  margin: auto 0;
  @include for-phone-only {
    padding: 35px;
  }
}
.header {
  font-size: 17px;
  line-height: 21px;
  font-family: 'VW Head';
  max-width: 800px;
  @include for-phone-only {
    font-size: 16px;
    line-height: 20px;
  }
}
button {
  margin-top: 35px;
  background: none;
  background-color: #00b0f0;
  color: #18224e;
  font-size: 16px;
  width: 139px;
  height: 40px;
  border-radius: 20px;
  border: none;
  cursor: pointer;

  @include for-tablet-only {
    width: 305px;
  }
  @include for-phone-only {
    width: 100%;
    max-width: 305px;
  }
}
.license {
  margin-top: 113px;
  display: flex;
  font-size: 14px;
  align-items: center;
  font-family: 'VW Head';
  @include for-phone-only {
    margin-top: 35px;
    font-size: 13px;
  }
}
.pdf-icon {
  width: 50px;
  height: 50px;
  margin-right: 20px;
  @include for-tablet-only {
    margin-right: 30px;
  }
  @include for-phone-only {
    margin-right: 23px;
  }
}
.license a {
  color: #00b0f0;
  text-decoration: none;
  font-weight: bold;
}
</style>
